const getAmountLabel = ({ amount, currency }) => {
	const amountWithCents = amount / 100;
	const formattedAmount = new Intl.NumberFormat('en', {
		style: 'currency',
		currency: 'USD',
	}).format(amountWithCents);

	if (amount && currency) {
		return `${formattedAmount}`;
	}
	return formattedAmount;
};

export default getAmountLabel;
